import { render, staticRenderFns } from "./bbs.vue?vue&type=template&id=b0c4fb84&scoped=true"
import script from "./bbs.vue?vue&type=script&lang=js"
export * from "./bbs.vue?vue&type=script&lang=js"
import style0 from "./bbs.vue?vue&type=style&index=0&id=b0c4fb84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c4fb84",
  null
  
)

export default component.exports